module.exports = __webpack_public_path__ + "img/3DSProjectPreview.63a438ae.gif";